import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { colors } from '../styles';

/**
 * #1390 — client-side not-found for unmatched main-domain routes.
 * SPA hosting still serves index.html with HTTP 200; this page is the
 * recovery surface so unknown paths are no longer a blank cream root.
 */
const NotFound = () => (
  <>
    <Helmet>
      <title>Page not found · Budgit</title>
      <meta name="robots" content="noindex" />
    </Helmet>
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: colors.background,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
        textAlign: 'center',
      }}
    >
      <Typography
        variant="h1"
        sx={{
          fontSize: { xs: '4rem', md: '6rem' },
          fontWeight: 800,
          color: colors.primary,
          lineHeight: 1,
          mb: 2,
        }}
      >
        404
      </Typography>
      <Typography
        variant="h5"
        sx={{ fontWeight: 700, color: colors.secondary, mb: 1 }}
      >
        Page not found
      </Typography>
      <Typography
        variant="body1"
        sx={{ color: colors.text.secondary, mb: 4, maxWidth: 420 }}
      >
        That link doesn&apos;t go anywhere in Budgit. Head home to get started or sign in.
      </Typography>
      {/* Plain RouterLink (not MUI Button) so tests without full MUI still see a real <a href="/"> */}
      <RouterLink
        to="/"
        style={{
          display: 'inline-block',
          backgroundColor: colors.primary,
          color: colors.secondary,
          fontWeight: 700,
          borderRadius: '50px',
          padding: '12px 32px',
          fontSize: '1.1rem',
          textDecoration: 'none',
          fontFamily: 'Quicksand, sans-serif',
        }}
      >
        Go home
      </RouterLink>
    </Box>
  </>
);

export default NotFound;
